import React, { useEffect, useRef, useState } from 'react'
import INCSUBButton from '../../components/common/Button/INCSUBButton';
import INCSUBSearchbar from '../../components/common/SearchBar/INCSUBSearchbar';
import './styleNotification.css'
import { toast } from 'react-toastify';
import { deleteCustomNotifications, getCustomNotifications } from '../../services/notificationServices';
import { useDispatch, useSelector } from 'react-redux';
import { setNotificationData } from '../../features/notifications/notificationSlice';
import { useNavigate } from 'react-router';
import INCSUBAddNotification from '../../components/notification/AddNotification';
import ReactPaginate from 'react-paginate';

function CustomNotification() {
    const [shimmer, setShimmer] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [pageNo, setPageNo] = useState(0);
    const notificationData = useSelector((state) => state.notification.notificationData);
    const [isOpenAddNotification, setIsOpenAddNotification] = useState(false)
    const refCardMenu = useRef();
    const [isOpenMenu, setIsOpenMenu] = useState()
    const [selectedNotification, setSelectedNotification] = useState(null);
    const [isAsk, setIsAsk] = useState(false);
    const [isOpenPopUp, setIsOpenPopup] = useState(false);
    const [notificationLoader, setNotificationLoader] = useState();

    const handleClickOutside = (event) => {
        if (refCardMenu.current && !refCardMenu.current.contains(event.target)) {
            setIsOpenMenu(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);




    const fetchNotification = async ({ notificationTitle = '', pageNo = 0, pageSize = 10 } = {}) => {
        setShimmer(true)
        try {
            const notificationData = await getCustomNotifications(notificationTitle, pageNo, pageSize);
            if (notificationData.status === 200) {
                dispatch(setNotificationData(notificationData.data.data))
            } else if (notificationData.status === 401) {
                window.localStorage.setItem('userData', null);
                window.localStorage.setItem('token', null);
                navigate('/login')
            } else if (![200, 401].includes(notificationData.status)) {
                toast.error(notificationData.data.message);
            }
        } catch (error) {
            toast.error("something Went Wrong");
        } finally {
            setShimmer(false)
        }
    }
    useEffect(() => {
        fetchNotification()
    }, [])
    function PaginatedItems() {
        const [itemOffset, setItemOffset] = useState(2);
        const endOffset = itemOffset;

        const pageCount = notificationData ? notificationData.totalPages : 0;
        // Invoke when user click to request another page.
        const handlePageClick = (event) => {
            setPageNo(event.selected);
            fetchNotification({ pageNo: event.selected })
            setCurrentPage(event.selected)
            setItemOffset(event.selected);
        };


        return (

            <div className='INCSUBCustomNotifications_list_section_container'>{
                !shimmer && notificationData && notificationData.customNotificationDetailsDtoList && notificationData.customNotificationDetailsDtoList.length > 0 && pageCount > 1 ? <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    forcePage={currentPage}
                /> : null
            }



            </div>


        );
    }

    const handleSearch = (key) => {
        fetchNotification(key, pageNo);
    }
    const formatDateTime = (dateTime) => {
        const date = new Date(dateTime);
        const options = { day: "2-digit", month: "short", year: "numeric" };
        const formattedDate = date.toLocaleDateString("en-GB", options).replace(",", "");
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const period = hours >= 12 ? "PM" : "AM";
        const formattedTime = `${hours % 12 || 12}:${minutes} ${period}`;

        return `${formattedDate} ${formattedTime}`;
    };

    const handleOpenNotification = () => {
        setIsOpenAddNotification(true);
        setSelectedNotification(null)
    }

    const handleDelete = async () => {
        setNotificationLoader(true);
        try {
            const data = await deleteCustomNotifications(selectedNotification.customNotificationId);
            if (data.status === 200) {
                const updatedData = notificationData.customNotificationDetailsDtoList.filter((n) => n.customNotificationId !== selectedNotification.customNotificationId)
                dispatch(setNotificationData({
                    ...notificationData,
                    customNotificationDetailsDtoList: updatedData
                }));
                setSelectedNotification(null);
                setIsOpenPopup(false);
                setIsAsk(false);
            } else if (data.status === 401) {
                window.localStorage.setItem('userData', null);
                window.localStorage.setItem('token', null);
                navigate('/login')
            } else if (![200, 401].includes(data.status)) {
                toast.error(data.data.message);
            }
        } catch (error) {
            toast.error("something Went Wrong");
        } finally {
            setNotificationLoader(false);
        }
    }


    return (
        <div className='INCSUBCustomNotification'>
            <div className='INCSUBCustomNotification_container'>
                <div className='INCSUBCustomNotification_filter_section_container'>
                    <div className="INCSUBPools_Search_filters_container">
                        <div className='INCSUBCustomNotification_filter_section'>
                            <INCSUBSearchbar placeholder={'Search by title / type'} param={{ func: handleSearch }} />

                        </div>

                    </div>
                    <div className='INCSUBCustomNotification_filter_section_btns_container'>
                        <INCSUBButton text='Create' clickFun={handleOpenNotification} />
                    </div>
                </div>
                <div className='INCSUBCustomNotification_userlist_section'>
                    <div className='INCSUBCustomNotification_userlist_section_table_conatiner'>
                        {!shimmer && notificationData && notificationData.customNotificationDetailsDtoList && notificationData.customNotificationDetailsDtoList.length > 0 ? notificationData.customNotificationDetailsDtoList.map((notification, index) => < div key={notification.customNotificationId} className='INCSUBNotificationList_li' >
                            <div className='INCSUBNotification_Image_container'>
                                <img src={notification.customNotificationImage ? notification.customNotificationImage : '/assets/images/notification/defaultNotification.png'} alt='notification_image' />
                            </div>
                            <div className='INCSUB_notification_info_container'>
                                <div className='INCSUBNotification_upper_body_container'>
                                    <div className='INCSUBnotification_head_container'>
                                        <div className='INCSUBNotification_heading'>{notification.customNotificationTitle}</div>
                                        <div className='INCSUBuser_profile_type'>{notification.customNotificationType}</div>
                                    </div>
                                    <div className='INCSUBNotification_edit_section'>
                                        <div className='INCSUBNotification_time'>{"⏳"}{formatDateTime(notification.customNotificationScheduleDateTime)} <span>{notification.customNotificationCreatedTime?`Created at: ${formatDateTime(notification.customNotificationCreatedTime)}`:null}</span></div>
                                        <svg onClick={() => setIsOpenMenu(notification.customNotificationId)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.0003 10.8307C10.4606 10.8307 10.8337 10.4576 10.8337 9.9974C10.8337 9.53716 10.4606 9.16406 10.0003 9.16406C9.54009 9.16406 9.16699 9.53716 9.16699 9.9974C9.16699 10.4576 9.54009 10.8307 10.0003 10.8307Z" stroke="black" stroke-opacity="0.6" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M10.0003 5.0026C10.4606 5.0026 10.8337 4.62951 10.8337 4.16927C10.8337 3.70903 10.4606 3.33594 10.0003 3.33594C9.54009 3.33594 9.16699 3.70903 9.16699 4.16927C9.16699 4.62951 9.54009 5.0026 10.0003 5.0026Z" stroke="black" stroke-opacity="0.6" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M10.0003 16.6667C10.4606 16.6667 10.8337 16.2936 10.8337 15.8333C10.8337 15.3731 10.4606 15 10.0003 15C9.54009 15 9.16699 15.3731 9.16699 15.8333C9.16699 16.2936 9.54009 16.6667 10.0003 16.6667Z" stroke="black" stroke-opacity="0.6" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        <div className='INCSUBnotification_crud'>
                                            {isOpenMenu === notification.customNotificationId ? <div className='menu' ref={refCardMenu}>
                                                <svg onClick={(e) => {
                                                    e.stopPropagation();
                                                    setSelectedNotification(notification);
                                                    setIsOpenAddNotification(true)

                                                }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8 13.3281H14" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M11 2.33609C11.2652 2.07087 11.6249 1.92188 12 1.92188C12.1857 1.92188 12.3696 1.95845 12.5412 2.02953C12.7128 2.1006 12.8687 2.20477 13 2.33609C13.1313 2.46741 13.2355 2.62331 13.3066 2.79489C13.3776 2.96647 13.4142 3.15037 13.4142 3.33609C13.4142 3.52181 13.3776 3.7057 13.3066 3.87728C13.2355 4.04886 13.1313 4.20477 13 4.33609L4.66667 12.6694L2 13.3361L2.66667 10.6694L11 2.33609Z" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                                <hr />
                                                <svg onClick={(e) => {
                                                    e.stopPropagation();
                                                    setIsOpenPopup(true);
                                                    setSelectedNotification(notification);
                                                    setIsAsk(true)
                                                }
                                                } width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M2 4H3.33333H14" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M12.6668 4.0026V13.3359C12.6668 13.6896 12.5264 14.0287 12.2763 14.2787C12.0263 14.5288 11.6871 14.6693 11.3335 14.6693H4.66683C4.31321 14.6693 3.97407 14.5288 3.72402 14.2787C3.47397 14.0287 3.3335 13.6896 3.3335 13.3359V4.0026M5.3335 4.0026V2.66927C5.3335 2.31565 5.47397 1.97651 5.72402 1.72646C5.97407 1.47641 6.31321 1.33594 6.66683 1.33594H9.3335C9.68712 1.33594 10.0263 1.47641 10.2763 1.72646C10.5264 1.97651 10.6668 2.31565 10.6668 2.66927V4.0026" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M6.6665 7.33594V11.3359" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M9.3335 7.33594V11.3359" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>


                                            </div> : null}
                                        </div>
                                    </div>
                                </div>
                                <div className='INCSUBNotification_lower_body_content'>{notification.customNotificationMessage}</div>
                            </div>
                        </div>) :(shimmer? < div className='INCSUBCustomNotification_conatiner_shimmer' > <div class="notification_shimmer-loading"></div>

                            <div class="notification_shimmer-loading"></div>
                            <div class="notification_shimmer-loading"></div>
                            <div class="notification_shimmer-loading"></div>
                            <div class="notification_shimmer-loading"></div></div>:null)}

                        {
                            !notificationData || notificationData.customNotificationDetailsDtoList?.length === 0 ? <div className='INCSUBNotification_empty'>Custom Notifications Not Available</div> : null
                        }
                    </div>
                </div>
                <PaginatedItems />
            </div>
            {isOpenAddNotification ? <INCSUBAddNotification setIsOpenAddNotification={setIsOpenAddNotification} notification={selectedNotification} /> : null}
            {isOpenPopUp ?
                <div className='INCSUBCategory_permission_popup'>{
                    isAsk ?
                        <div className='INCSUBCategory_ask_container' >
                            <div className='INCSUBCategory_ask' style={{ display: notificationLoader ? 'none' : null }}>
                                <svg width="100" height="94" viewBox="0 0 100 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="49.0815" cy="46.0102" r="32.0883" fill="#FF6565" />
                                    <circle cx="13.778" cy="7.87368" r="7.87368" fill="#FF6565" fill-opacity="0.2" />
                                    <circle cx="93.1719" cy="15.749" r="5.90526" fill="#FF6565" fill-opacity="0.2" />
                                    <ellipse cx="3.93684" cy="69.8744" rx="3.93684" ry="3.60877" fill="#FF6565" fill-opacity="0.2" />
                                    <circle cx="34.777" cy="91.2028" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                    <circle cx="85.2985" cy="83.3356" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                    <circle cx="89.235" cy="58.3903" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                    <circle cx="56.4274" cy="3.93717" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                    <path d="M47.5491 51.7008L46 32H52.1168L50.5677 51.7008H47.5491ZM46.278 60.0022V54.4812H51.8388V60.0022H46.278Z" fill="white" />
                                </svg>




                                <div className='INCSUBCategory_permission_header'>
                                    Are you sure to delete this notification?
                                </div>
                                <div className='INCSUBCategory_permission_btn_container'>
                                    <div className="INCSUBCategory_image_upload_btn">
                                        <div className='INCSUBCategory_upload_btn' onClick={() => handleDelete(selectedNotification)}>Delete</div>
                                        <div className='upload_cancel_btn' onClick={() => setIsOpenPopup(false)}>Cancel</div>
                                    </div>
                                </div>
                            </div>
                            {
                                notificationLoader ? <div className='categoryloader' /> : null
                            }
                        </div> : <div className='INCSUBCategory_ask_container'>
                            <svg width="100" height="94" viewBox="0 0 100 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="49.0805" cy="46.0102" r="32.0883" fill="#FF6565" />
                                <path d="M59 37L41 55" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M41 37L59 55" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                                <circle cx="13.778" cy="7.87368" r="7.87368" fill="#FF6565" fill-opacity="0.2" />
                                <circle cx="93.1709" cy="15.749" r="5.90526" fill="#FF6565" fill-opacity="0.2" />
                                <ellipse cx="3.93684" cy="69.8744" rx="3.93684" ry="3.60877" fill="#FF6565" fill-opacity="0.2" />
                                <circle cx="34.777" cy="91.2028" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                <circle cx="85.2985" cy="83.3356" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                <circle cx="89.234" cy="58.3903" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                <circle cx="56.4274" cy="3.93717" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                            </svg>
                            <div className='INCSUBCategory_permission_header'>
                                Deleted successfully
                            </div>
                            <div className='INCSUBCategory_permission_text'></div>
                            <div className='INCSUBCategory_permission_btn_container'>
                                <div className="INCSUBCategory_image_upload_btn">
                                    <div className='INCSUBCategory_upload_btn' onClick={() => setIsOpenPopup(false)}>Ok, Got it</div>
                                    {/* <div className='upload_cancel_btn'>Cancel</div> */}
                                </div>
                            </div>
                        </div>
                }


                </div> : null
            }
        </div >
    )
}

export default CustomNotification
